import { API, unwrapData } from '../axios-instance'
import { LanguagesEnum } from '../identity'
import { TranslationStatuses } from '../shared'
import {
  CreateValueParams,
  ListValuesParams,
  MemberValueStat,
  OrderValuesParams,
  Value,
  ValueTranslation,
  ValueTranslationParams,
} from './types'

export const getValuesTranslationsStatus = async () => {
  return await API.get<TranslationStatuses>('/value/values/translations/status').then(unwrapData)
}

export const listValues = async (params?: ListValuesParams) => {
  return await API.get<Value[]>('/value/values', { params }).then(unwrapData)
}

export const createValue = async (params: CreateValueParams) => {
  return await API.post<Value>('/value/values', params).then(unwrapData)
}

export const updateValue = async (valueId: string, params: CreateValueParams) => {
  return await API.put<Value>(`/value/values/${valueId}`, params).then(unwrapData)
}

export const orderValues = async (params: OrderValuesParams) => {
  return await API.put<boolean>('/value/values/ordering', params).then(unwrapData)
}

export const deleteValue = async (valueId: string) => {
  return await API.delete<boolean>(`/value/values/${valueId}`)
}

export const getMemberQualityStats = async (memberId: string) => {
  return await API.get<MemberValueStat[]>(`/value/qualities/${memberId}/allTimeStats`).then(
    unwrapData,
  )
}

export const listValuesAndQualitiesTranslations = async (language: LanguagesEnum) => {
  return await API.get<ValueTranslation[]>(`/value/values/translations/${language}`).then(
    unwrapData,
  )
}

export const updateValuesAndQualitiesTranslations = async (
  language: LanguagesEnum,
  params: ValueTranslationParams[],
) => {
  return await API.put<ValueTranslation[]>(`/value/values/translations/${language}`, params).then(
    unwrapData,
  )
}
